export const CREATE_AND_EDIT_EMAIL_TEMPLATES =
  'CREATE_AND_EDIT_EMAIL_TEMPLATES';
